/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const reviewDiv = document.querySelector("div[id*='loox_reviews_loox_rating']");
  if (reviewDiv) {
    const nextEl = reviewDiv.nextElementSibling;
    
    if (nextEl && nextEl.classList.contains("product_stat_wrapper")) {
      // Create wrapper div
      const wrapper = document.createElement("div");
      wrapper.classList.add("reviews_stats_wrapper"); // add your custom class

      // Insert wrapper before reviewDiv
      reviewDiv.parentNode.insertBefore(wrapper, reviewDiv);

      // Move both reviewDiv and nextEl into wrapper
      wrapper.appendChild(reviewDiv);
      wrapper.appendChild(nextEl);
    }
  }
  // Add custom code below this line

  const selectors = [
    ".template-product .tabbing-section a.button",
    ".template-product .brick__section .hero__button a.btn",
    ".template-product .comparison-table a.comparison-table__button",
    ".template-product .multicolumn .column__btn a.btn"
  ];

  const buttons = document.querySelectorAll(selectors.join(","));

  buttons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      if (this.getAttribute("href") === "#") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  });


  function offsoundAllVideos( trigger = null ) {
    let posterWrapper = '';
    console.log("call the video pause",trigger)
    const isMobile = window.innerWidth <= 767;

    const allOtherVideos = document.querySelectorAll('video');
    allOtherVideos.forEach((video) => {
      video.muted = true;
      const parentDiv = video.parentElement;
      // find any button matching one of these classes
      const muteBtn = parentDiv.querySelector(
        ".prdgalleyMute, .glb_mute, .mutedButton"
      );
      if (muteBtn) {
        muteBtn.classList.add("muted");
      }
    });




    const videoWrappers = document.querySelectorAll('.video_selector');
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');

      

      const muteBtn = wrapper.querySelector('.glb_mute');
      const playBtn = wrapper.querySelector('.glb_play');
      posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      if( shouldAutoplay() )
      {
        if (video && !video.muted) {
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
      }
      else{
        video.pause();
        if( playBtn ){
          playBtn.classList.remove('playing');
        }
        if (posterWrapper) posterWrapper.style.opacity = 1;
      }
    });

  }
  function normalizeShopifyVideoUrl(url) {
    // If the URL already starts with cdn.shopify.com, return it
    if (url.includes("cdn.shopify.com/videos/c/vp/")) {
      return url;
    }

    // If it's the frontend domain (bosant.no/cdn/shop/videos/c/vp/...)
    if (url.includes("/cdn/shop/videos/c/vp/")) {
      // Extract the path after `/cdn/shop/videos/c/vp/`
      const path = url.split("/cdn/shop/videos/c/vp/")[1];
      return `https://cdn.shopify.com/videos/c/vp/${path}`;
    }

    // Fallback – return original
    return url;
  }
  function initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              if( playBtn ){
                playBtn.classList.add('playing');
              }
              
            })
            .catch(() => {
              if( playBtn ){
                playBtn.classList.remove('playing');
              }
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          if( otherPlayBtn ){
            otherPlayBtn.classList.remove('playing');
          }
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          if( playBtn ){
            playBtn.classList.remove('playing');
          }
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        let src = normalizeShopifyVideoUrl(getSrc());
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }
        if( playBtn ){
          playBtn.classList.toggle('playing', autoplay);
        }
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.video_selector');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      if( playBtn ){
        playBtn.addEventListener('click', () => {
          if (video.paused) {
            offsoundAllVideos('trigger');
            safePlay();
            video.muted = false;
            if (muteBtn) {
              muteBtn.classList.remove('muted');
            }
          } else {
            if (muteBtn) {
              muteBtn.classList.add('muted');
            }
            pauseVideo();
          }
        });
      }

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }


  initTabbingSections();

  // Re-run when Shopify customizer does section reload
  document.addEventListener("shopify:section:load", function() {
    initTabbingSections();
  });

  function initTabbingSections() {
    document.querySelectorAll(".tabbing-section").forEach(section => {
      const tabs = section.querySelectorAll(".tabbing-tab");
      const contents = section.querySelectorAll(".tab_content");

      if (!tabs.length || !contents.length) return;

      // Reset everything
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // Activate first by default
      tabs[0].classList.add("active");
      contents[0].classList.add("active");

      tabs.forEach(tab => {
        tab.addEventListener("click", function() {
          const tabId = this.getAttribute("data-tab");

          // Remove active from all inside this section
          tabs.forEach(t => t.classList.remove("active"));
          contents.forEach(c => c.classList.remove("active"));

          // Add active to clicked + matching content
          this.classList.add("active");
          const target = section.querySelector("#" + tabId);
          if (target) target.classList.add("active");
        });
      });
    });
  }
  // Public init function: pass selector string for all slider containers
  function initResponsiveFlickities(selector = '.block__icon__row') {
    const FlickityCtor = (window.theme && window.theme.Flickity) || window.Flickity;
    if (!FlickityCtor) {
      console.warn('Flickity not found.');
      return function noop() {};
    }

    const elements = Array.from(document.querySelectorAll(selector));
    if (!elements.length) return function noop() {};

    const instanceMap = new WeakMap();
    let resizeTimer = null;

    function shouldBeActive(el) {
      const slider = el.querySelector('.slider') || el;
      const hasFullIcon = slider.querySelectorAll('.block__icon__container--full').length > 0;
      return window.innerWidth <= 767 && !hasFullIcon;
      // If you want active *only if no "full icon"* and on mobile
    }

    function initOne(el) {
      if (instanceMap.has(el)) return; // already initialized

      const slider = el.querySelector('.slider') || el;
      const totalSlides = slider.querySelectorAll('.block__icon__container').length;
      const cellsToShowMobile = parseInt(el.dataset.mobile, 10) || 1;

      const contain = totalSlides <= cellsToShowMobile;
      const wrapAround = totalSlides > cellsToShowMobile;

      const flkty = new FlickityCtor(slider, {
        cellAlign: 'left',
        contain: contain,
        imagesLoaded: true,
        wrapAround: wrapAround,
        prevNextButtons: false,
        pageDots: true,
        draggable: wrapAround,
        touchVerticalScroll: false,
        groupCells: 2,
        // optionally add groupCells or other responsive options
      });

      instanceMap.set(el, flkty);
    }

    function destroyOne(el) {
      const flkty = instanceMap.get(el);
      if (flkty) {
        try { flkty.destroy(); } catch (e) { console.warn('Error destroying flickity:', e); }
        instanceMap.delete(el);
      }
    }

    function applyState() {
      elements.forEach(el => {
        if (shouldBeActive(el)) {
          initOne(el);
        } else {
          destroyOne(el);
        }
      });
    }

    let resizeTimer1;
    let lastWidth1 = window.innerWidth;
    function onResizeDebounced() {
      clearTimeout(resizeTimer);
      resizeTimer1 = setTimeout(() => {
        const currentWidth1 = window.innerWidth;
        if (currentWidth1 !== lastWidth1) {
          applyState();
          lastWidth1 = currentWidth1; // update for next check
        }
      }, 200);
    }

    // initial
    applyState();
    window.addEventListener('resize', onResizeDebounced);

    // return cleanup
    return function destroyAll() {
      window.removeEventListener('resize', onResizeDebounced);
      elements.forEach(el => {
        destroyOne(el);
      });
    };
  }

  initResponsiveFlickities();

  function initAfterBeforeTestimonial(section) {
    const desktop = parseInt(section.dataset.desktop) || 3;
    const tablet  = parseInt(section.dataset.tablet)  || 2;
    const mobile  = parseInt(section.dataset.mobile)  || 1;

    const sectionID = section.getAttribute('data-section-id');
    //console.log("sectionID",sectionID);
    let flkty = null;

    function getGroupCells() {
      if (window.innerWidth >= 1024) return desktop;
      if (window.innerWidth >= 768) return tablet;
      return mobile;
    }

    function initFlickity() {
      const totalSlides = section.querySelectorAll(".slider .carousel-cell").length;
      const slidesToShow = getGroupCells();

      const contain_v = totalSlides > slidesToShow ? false : true;
      const wrap_v    = totalSlides > slidesToShow ? true : false;

      // Destroy existing instance before re-init
      if (flkty) {
        flkty.destroy();
      }

      flkty = new window.theme.Flickity(section.querySelector(".slider"), {
        cellAlign: "left",
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: false,
        prevNextButtons: wrap_v,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        //groupCells: getGroupCells(), // ✅ this updates slides per view
      });
    }

    // Init on load
    initFlickity();

    // Re-init on resize (debounced for performance)
    let resizeTimeout;
    let lastWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      const currentWidth = window.innerWidth;

      // Only trigger if width changed
      if (currentWidth !== lastWidth) {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          initFlickity(); // your re-init logic
          lastWidth = currentWidth; // update after re-init
        }, 200);
      }
    });

    // --- MODAL SETUP ---
    const modal = section.querySelector(".readMoreModal");
    if( modal ){
      const modalContent = modal.querySelector(".modal-content .content");
      const closeBtn = modal.querySelector(".close");
      const readMore_button = section.querySelectorAll(".read-more-btn"); 

      if (closeBtn) {
          closeBtn.addEventListener("click", () => {
              modal.classList.remove("open")
          });
      }
      window.addEventListener("click", (event) => {
          if (event.target === modal) {
              modal.classList.add("open")
          }
      });
      readMore_button.forEach(button => {
          button.addEventListener('click', (event) => {
              const parent = event.target.closest('.slide-item-content-desc');
              const parentInnertext = parent.querySelector(".descriptions_full");
              modalContent.innerHTML = parentInnertext.innerHTML;
              modal.classList.add("open")
          });
      });
    }
  }
  //console.log("ffff",document.querySelectorAll(".after_before_testimonial").length)
  document.querySelectorAll(".after_before_testimonial").forEach(sectionjj => {
    const sectionID = sectionjj.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
    initAfterBeforeTestimonial(sectionjj);
  });
  // --- Re-init inside Shopify Customizer ---
  document.addEventListener("shopify:section:load", function(event) {
    const sectionjj = event.target.querySelector(".after_before_testimonial");
    if (sectionjj) {
      const sectionID = sectionjj.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
      initAfterBeforeTestimonial(sectionjj);
    }
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
